import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userLogged: null
  },
  mutations: {
    setUser(state, payload) {
      state.userLogged = payload;
    }
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin]
});
